import { render, staticRenderFns } from "./VehicleLookUp.vue?vue&type=template&id=faf858ca&"
import script from "./VehicleLookUp.vue?vue&type=script&lang=js&"
export * from "./VehicleLookUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports